module.exports = __webpack_public_path__ + "static/media/linkedin.ac16119e.59445d88.svg";